import axios from "axios";

// Detect if running inside Tauri (Desktop App)
const isTauri = window.__TAURI__ !== undefined;

// Base URL
// - Desktop: backend running locally
// - SaaS: frontend served by nginx, which proxies /api to the backend
const backendBaseURL = isTauri
  ? "http://127.0.0.1:3000/api"
  : "/api";

console.log("🌐 Backend Base URL:", backendBaseURL);

// Create Axios instance
const api = axios.create({
  baseURL: backendBaseURL,
});

// Attach JWT token (if present) to every request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("lotledgerToken");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    console.log(`📤 API Request: ${config.method?.toUpperCase()} ${config.url}`);
    return config;
  },
  (error) => {
    console.error("❌ API Request Error:", error);
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    console.log(`✅ API Response from ${response.config.url}`, response.data);
    return response;
  },
  (error) => {
    // Avoid crashing when error.config is missing
    const url = error?.config?.url || "(unknown url)";
    const status = error?.response?.status;
    const data = error?.response?.data;

    console.error(`❌ API Error from ${url}`, { status, data, error });

    // Optional: if token is invalid/expired, kick them back to login
    if (status === 401) {
      // Don’t auto-clear during login calls, only for protected calls
      const isAuthCall = url.includes("/auth/");
      if (!isAuthCall) {
        localStorage.removeItem("lotledgerToken");
      }
    }

    return Promise.reject(error);
  }
);

// Convenience wrappers (use whichever you want in components)
export const fetchAuctionHouses = async () => {
  console.log("📡 Fetching auction houses...");
  // SaaS "available" endpoint (global selected + custom)
  return api.get("/auction-houses/available");
};

export const fetchAuctions = async () => {
  console.log("📡 Fetching auctions...");
  return api.get("/auctions");
};

export const fetchItems = async () => {
  console.log("📡 Fetching items...");
  return api.get("/items");
};

export default api;
